import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BAInRuralDevelopment = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '190px',marginLeft:'70px' }}>
      <h1 style={{ textAlign: 'center' }}>
        📘 Bachelor of Arts in Rural Development and Agricultural Extension
      </h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BA in Rural Development and Agricultural Extension at Admas University is designed to equip students with the knowledge and skills needed to improve rural livelihoods, promote sustainable agriculture, and drive community-based development. The program integrates agricultural sciences, economics, sociology, and communication strategies for effective rural transformation.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To provide a solid foundation in rural development theory and practices.</li>
          <li>To train professionals in effective agricultural extension and advisory services.</li>
          <li>To enhance the capacity of students to address poverty, food insecurity, and rural-urban inequalities.</li>
          <li>To promote participatory development and sustainable use of natural resources.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Key Courses</h2>
        <ul>
          <li>Introduction to Rural Development</li>
          <li>Principles of Agricultural Extension</li>
          <li>Community Mobilization and Participation</li>
          <li>Communication for Development</li>
          <li>Gender and Development</li>
          <li>Project Planning and Management</li>
          <li>Natural Resource Management</li>
          <li>Monitoring and Evaluation</li>
          <li>Development Policy and Strategy</li>
          <li>Senior Research Project</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Successful completion of preparatory education with a qualifying university entrance score.</li>
          <li>Relevant TVET diploma (10+3 or Level 4) holders may be eligible through bridging programs.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can pursue careers in government agencies, NGOs, agricultural extension services, rural development projects, international development organizations, and research institutions. Roles may include development officer, extension worker, rural project manager, and policy advisor.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Strong focus on fieldwork and real-world application.</li>
          <li>Courses aligned with Ethiopia’s rural development policies and SDGs.</li>
          <li>Nationwide learning centers supporting distance education.</li>
          <li>Experienced faculty with community engagement background.</li>
        </ul>
      </section>
    </div>
  );
};

export default BAInRuralDevelopment;